<div class="modal-header">
    <h1 class="modal-title">{{ headerText }}</h1>
</div>
<div class="modal-body">
    <p [innerHTML]="bodyText"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn" (click)="saveAndCloseModal()"
            [ngClass]="{'btn-danger': (warningLevel == null || warningLevel == 'danger'), 'btn-primary': warningLevel == 'primary', 'btn-success': warningLevel == 'success'}">
    {{ confirmButtonText }}</button>
    <button type="button" class="btn btn-default" (click)="closeModal()">{{ cancelButtonText }}</button>
</div>